export default "__VITE_ASSET__DC7XY7QD__"